import { render } from "./collection-products.vue?vue&type=template&id=1975347c"
import script from "./collection-products.vue?vue&type=script&lang=js"
export * from "./collection-products.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__